import { FC } from 'react';
import classNames from 'classnames';

import { Badge } from '@/components/atoms/badge';

import styles from './storeStatusIndicator.module.scss';

interface IStoreStatusIndicatorProps {
  isOpen: boolean;
  statusLabel?: string | null;
  className?: string;
  badgeClassName?: string;
  badgeClosedClassName?: string;
  messageClassName?: string;
  textColor?: string;
  fallbackLabel?: string;
}

const StoreStatusIndicator: FC<IStoreStatusIndicatorProps> = ({
  isOpen,
  statusLabel,
  className,
  badgeClassName,
  badgeClosedClassName,
  messageClassName,
  textColor,
  fallbackLabel = 'Not Specified',
}) => {
  return (
    <div className={classNames(styles.status, className)}>
      <Badge
        aria-label={`Store status: ${isOpen ? 'OPEN' : 'CLOSED'}`}
        aria-live="polite"
        className={classNames(
          styles.status__badge,
          badgeClassName,
          !isOpen && [styles.status__badge_closed, badgeClosedClassName],
        )}
        role="status"
      >
        {isOpen ? 'OPEN' : 'CLOSED'}
      </Badge>
      <span
        className={classNames(styles.status__message, messageClassName)}
        style={{ color: textColor }}
      >
        {statusLabel ?? fallbackLabel}
      </span>
    </div>
  );
};

export { StoreStatusIndicator };
